const initState = {
  active: false,
  file: undefined,
};
const galleryReducer = (state = initState, action) => {
  switch (action.type) {
    case "SHOW_GALLERY":
      return {
        ...state,
        active: true,
        file: action.payload,
      };
    case "HIDE_GALLERY":
      return {
        ...state,
        active: false,
      };
    default:
      return state;
  }
};

export default galleryReducer;
